import { AudioManager } from "../../../AudioManager";
import { GameManager } from "../../../GameManager";
import { Language } from "../../../Types";

export class LanguageSelectionMenu extends Phaser.GameObjects.Container {

    public static LANGUAGES = ["English", "Español", "Català", "Deutsch", "Français", "Italiano", "Português - BR", "Nederlands", "Русский", "日本語"];

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        this.x = 270;
        this.y = -125;

        const w = 250;
        const h = 565;

        const background = new Phaser.GameObjects.Graphics(this.scene);
        background.fillStyle(0xf6f5eb);
        background.fillRect(0, 0, w, h);
        this.add(background);

        const languages = Object.values(Language);

        for (let i = 0; i < languages.length; i++) {

            const langLabel = new Phaser.GameObjects.Text(this.scene, 30, i * 54 + 25, LanguageSelectionMenu.LANGUAGES[i], {fontFamily: "OpenSans-CondLight", fontSize: "38px", color: "#A17A65"});
            langLabel.setInteractive({useHandCursor: true});
            langLabel.on("pointerdown", () => {
                GameManager.setLanguage(languages[i]);
                AudioManager.playSound("btn_press");
            });

            langLabel.on("pointerover", () => {
                langLabel.setColor("#e40a49");
            });

            langLabel.on("pointerout", () => {
                langLabel.setColor("#A17A65");
            });

            this.add(langLabel);
        }
    }
}